// extracted by mini-css-extract-plugin
export default {"displayNone":"NavigationMobile_displayNone__5ZA4x","displayBlock":"NavigationMobile_displayBlock__ATe7e","container":"NavigationMobile_container__so-Ty"};